import React, { createContext, PropsWithChildren, useState } from "react";
import { AgTechButton, AgTechButtonProps } from "./AgTechButtons";

export type AgTechButtonGroupProps = {
    selectedButton?: string,
    buttons: AgTechButtonProps[]
}

const AgTechButtonGroup = (props: PropsWithChildren<AgTechButtonGroupProps>) => {
    let [selectedButton, setSelectedButton] = useState(props.selectedButton ?? props.buttons[0]?.text);

    return (
        <div className="column-based-vertically-centered container">
            {props.buttons.map((btn, index) => {
                let isButtonSelected = btn.text === selectedButton;

                const btnSelected = isButtonSelected ? 'button-highlight' : '';
                const btnBorderRadius = index === 0 ? 'rounded-l' : index === props.buttons.length - 1 ? 'rounded-r !border-r' : '';

                return (
                    <AgTechButton
                        text={btn.text}
                        {...btn}
                        action={async e => {
                            setSelectedButton(btn.text);
                            await btn.action?.(e);
                        }}
                        classes={`rounded-none border-r-0 font-semibold ${btnBorderRadius} ${btnSelected}`}
                    />
                )
            })}
        </div>
    )
}

export default AgTechButtonGroup;